import { heroVisualImage, heroHotWords } from "@/mocks/scandal";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* 背景极淡的纹理层 */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-x-0 top-0 h-px bg-foreground-950/8" />
        <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full bg-primary-100/50 blur-3xl" />
        <div className="absolute -left-24 top-40 h-80 w-80 rounded-full bg-accent-100/60 blur-3xl" />
      </div>

      <div className="relative mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-10 px-4 pb-16 pt-14 md:px-6 md:pb-24 md:pt-20 lg:grid-cols-[1.05fr_0.95fr]">
        {/* 文案侧（优先） */}
        <div id="search" className="scroll-mt-28">
          <p className="inline-flex items-center gap-2 rounded-full border border-foreground-950/10 bg-background-50 px-3 py-1 font-label text-xs tracking-wide text-foreground-600">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-60" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
            </span>
            人物黑历史 · 背景检索档案站
          </p>

          <h1 className="mt-6 font-heading text-[34px] font-black leading-[1.18] tracking-tight text-foreground-950 md:text-[46px]">
            把「黑历史」当资料来做，
            <br />
            <span className="text-primary-600">起底、深扒、揭秘</span>逐条留痕。
          </h1>

          <p className="mt-5 max-w-xl text-[15px] leading-7 text-foreground-700">
            网黑料专注<strong className="font-semibold text-foreground-950">人物黑历史深扒</strong>与<strong className="font-semibold text-foreground-950">背景揭秘</strong>：
            以人物为单位建立起底档案，以时间为轴归档内幕线索。每个结论都标可信度，每条料都留出处，不做情绪放大器，只做可核验的检索台。
          </p>

          {/* 工具型检索条（纯展示） */}
          <div className="mt-8 flex max-w-xl flex-col gap-3 sm:flex-row sm:items-center">
            <div className="flex flex-1 items-center gap-3 rounded-lg border border-foreground-950/10 bg-background-50 px-4 py-3 transition-colors focus-within:border-primary-400">
              <i className="ri-search-line text-lg text-foreground-500" />
              <input
                className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
                placeholder="输入想深扒的人物或事件…"
              />
            </div>
            <button
              type="button"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-foreground-950 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
            >
              开始深扒
              <i className="ri-focus-3-line text-sm" />
            </button>
          </div>

          <div className="mt-4 flex max-w-xl flex-wrap items-center gap-x-2 gap-y-2">
            <span className="whitespace-nowrap font-label text-xs text-foreground-500">正在被扒：</span>
            {heroHotWords.map((w, i) => (
              <a
                key={w.word}
                href={w.url}
                className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900 transition-colors hover:bg-accent-200"
              >
                #{w.word}
                {i < heroHotWords.length - 1 ? "" : ""}
              </a>
            ))}
          </div>

          <dl className="mt-9 grid max-w-xl grid-cols-3 gap-px overflow-hidden rounded-lg border border-foreground-950/8 bg-foreground-950/8">
            {[
              { k: "起底档案", v: "3.4k+" },
              { k: "深扒专题", v: "128" },
              { k: "待核实线索", v: "42%" },
            ].map((s) => (
              <div key={s.k} className="bg-background-50 px-4 py-4 text-center">
                <dd className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{s.v}</dd>
                <dt className="mt-1 font-label text-xs text-foreground-500">{s.k}</dt>
              </div>
            ))}
          </dl>
        </div>

        {/* 视觉侧（陪衬） */}
        <div className="relative mx-auto w-full max-w-sm lg:max-w-none">
          <div className="relative overflow-hidden rounded-xl border border-foreground-950/10">
            <img
              src={heroVisualImage}
              alt="网黑料档案检索：人物黑历史起底与背景揭秘"
              title="网黑料深扒 人物起底 背景揭秘"
              className="h-[340px] w-full object-cover object-top sm:h-[400px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-transparent to-transparent" />

            <div className="absolute left-4 top-4 flex flex-wrap gap-2">
              <span className="rounded-md bg-background-50/95 px-2.5 py-1 font-label text-xs text-foreground-950">实锤 31%</span>
              <span className="rounded-md bg-accent-500 px-2.5 py-1 font-label text-xs text-background-50">待核实 42%</span>
            </div>

            <div className="absolute bottom-4 left-4 right-4">
              <p className="font-label text-[11px] tracking-[0.3em] text-background-200">DEEP DIVE INDEX</p>
              <p className="mt-1 font-heading text-lg font-semibold text-background-50">
                一处留痕，一处档案
              </p>
            </div>
          </div>

          {/* 浮动小卡片 */}
          <div className="absolute -left-4 -top-4 hidden items-center gap-2 rounded-lg border border-foreground-950/8 bg-background-50 px-3 py-2 shadow-sm md:flex">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-600">
              <i className="ri-folder-user-line text-base" />
            </span>
            <div>
              <p className="font-label text-[11px] text-foreground-500">新增起底档案</p>
              <p className="text-xs font-semibold text-foreground-950">今日 +12</p>
            </div>
          </div>
          <div className="absolute -right-4 top-1/2 hidden items-center gap-2 rounded-lg border border-foreground-950/8 bg-background-50 px-3 py-2 shadow-sm md:flex">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-700">
              <i className="ri-focus-2-line text-base" />
            </span>
            <div>
              <p className="font-label text-[11px] text-foreground-500">可信度标注</p>
              <p className="text-xs font-semibold text-foreground-950">分级可核验</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}